import {
  getDeliverabilitySettings,
  getDomainAuthentication,
  updateDeliverabilitySettings,
  verifyDomainAuthentication,
} from "@/features/settings/api/deliverability";
import { showErrorFromMutation, showSuccess } from "@/shared/utils/toast";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// get deliverability settings hook
export const useGetDeliverabilitySettings = () => {
  return useQuery({
    queryKey: ["deliverability-settings"],
    queryFn: getDeliverabilitySettings,
    onError: (error) => {
      showErrorFromMutation(
        error,
        error.message || "Failed to get deliverability settings.",
      );
    },
  });
};


// update deliverability settings hook
export const useUpdateDeliverabilitySettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    scope: { id: "deliverability-settings" },
    mutationFn: (data) => updateDeliverabilitySettings(data),
    onError: (error) => {
      showErrorFromMutation(
        error,
        error.message || "Failed to update deliverability settings.",
      );
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["deliverability-settings"] });
      showSuccess("Deliverability settings updated successfully!");
      return data;
    },
  });
};

export const useGetDomainAuthentication = () => {
  return useQuery({
    queryKey: ["email-domain-authentication"],
    queryFn: getDomainAuthentication,
  });
};

export const useVerifyDomainAuthentication = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (selectors) => verifyDomainAuthentication(selectors),
    onSuccess: (data) => {
      queryClient.setQueryData(["email-domain-authentication"], data);
      showSuccess("Domain authentication checked successfully!");
    },
    onError: (error) => {
      showErrorFromMutation(error, "Failed to check domain authentication");
    },
  });
};
